/**
 * Detalhe adicional de um evento do pedido, quando ele acrescenta algo.
 *
 * O core manda `description` e `statusDetails` em todo evento, e na maioria deles os dois são
 * a mesma frase ("Aguardando pagamento via Pix"). Exibir sempre os dois duplicaria a linha em
 * quase toda a timeline.
 *
 * A exceção é justamente onde a informação importa: numa recusa, o `description` diz "Erro na
 * pré-autorização" e o `statusDetails` diz *por quê* — "CPF do Pagador ou Beneficiário Final não
 * encontrado na Receita Federal". É a frase que resolve o chamado, e ela não aparecia em lugar
 * nenhum do portal.
 *
 * @param description Texto do status, já traduzido pelo core.
 * @param statusDetails Detalhe do mesmo evento; pode vir ausente ou repetido.
 * @returns O detalhe quando ele diz algo novo; `undefined` quando repete a descrição.
 */
export const getAdditionalDetail = (
  description?: string,
  statusDetails?: string
): string | undefined => {
  const detail = statusDetails?.trim()

  if (!detail) return undefined

  return detail === description?.trim() ? undefined : detail
}
